/**
 * The `DiscoveryProbeService.onChange` hook that makes `onboarding.discovery.v1` a real
 * *live* query: every per-candidate status transition (probing → reachable →
 * verified/unreachable) publishes a `domain.entity-changed` event, which
 * `LiveQueryEngine` reruns the query's `invalidateOn` subscription against — the same
 * broad "any entity changed, rerun the read" invalidation `owner-views.ts`'s queries use.
 */
export function discoveryInvalidation(bus, now = () => new Date().toISOString()) {
    return () => {
        bus.publish({
            occurredAt: now(),
            payload: {
                action: "updated",
                entityId: "onboarding-discovery",
                entityType: "onboarding-discovery-candidate",
            },
            type: "domain.entity-changed",
        });
    };
}
//# sourceMappingURL=discovery-invalidation.js.map